import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Container, Provider, FallbackBackground, ImageContainer, BottomWrap2, Text, } from "./CustomThumbnail.styled";
var LargeFontSizeTable = new Map([
    [7, 30],
    [10, 26],
    [14, 23],
    [20, 21],
    [-1, 19],
]);
var SmallFontSizeTable = new Map([
    [7, 20],
    [10, 18],
    [14, 16],
    [20, 14],
    [-1, 12],
]);
var BOTTOM_WRAP_COLORS = [
    "#ec0725", // red
    "#08711d", //green
    "#0c8505", //lite green
    "#1e3a8a", // deep blue
    "#cc11da", // deep pink
    "#e509a4", // pink
    "#f10151", //lite pink
    "#7106c9", // purple
    "#002997", // lite purple
    "#0cbd68",
    "#3525df",
    "#14b8a6",
    "#f59e0b",
    "#db2777",
    "#059669",
    "#fd860e", //deep yellow
    "#e16808",
    "#1bdf06", // deep lime
    "#056cfc", // lime
];
function calculateFontSize(length, isSmallContainer) {
    var fontTable = isSmallContainer ? SmallFontSizeTable : LargeFontSizeTable;
    var thresholds = Array.from(fontTable.keys()).sort(function (a, b) { return a - b; });
    for (var _i = 0, thresholds_1 = thresholds; _i < thresholds_1.length; _i++) {
        var threshold = thresholds_1[_i];
        // skip the -1 size
        if (threshold < 0)
            continue;
        var value = fontTable.get(threshold);
        // skip if we can't find the value (shouldn't happen, but just in case)
        if (value === undefined)
            continue;
        // if the length does not exceed the threshold, we found the proper size
        if (length <= threshold)
            return value;
    }
    var fallback = fontTable.get(-1);
    if (fallback === undefined) {
        throw new Error("Fallback font size not found");
    }
    return fallback;
}
// Add a function to generate a consistent color based on a string
var getConsistentColor = function (str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var index = Math.abs(hash) % BOTTOM_WRAP_COLORS.length;
    return BOTTOM_WRAP_COLORS[index];
};
var CustomThumbnail = function (_a) {
    var imageUrl = _a.imageUrl, title = _a.title, provider = _a.provider;
    var _b = useState(false), imageError = _b[0], setImageError = _b[1];
    var _c = useState(null), containerWidth = _c[0], setContainerWidth = _c[1];
    var containerRef = useRef(null);
    var color = getConsistentColor(title);
    useEffect(function () {
        var img = new Image();
        img.src = imageUrl;
        img.onerror = function () { return setImageError(true); };
    }, [imageUrl]);
    useEffect(function () {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.offsetWidth);
            var resizeObserver_1 = new ResizeObserver(function (entries) {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    setContainerWidth(entry.contentRect.width);
                }
            });
            resizeObserver_1.observe(containerRef.current);
            return function () {
                if (containerRef.current) {
                    resizeObserver_1.unobserve(containerRef.current);
                }
            };
        }
    }, []);
    var isSmallContainer = containerWidth !== null && containerWidth < 100;
    var fontSize = calculateFontSize(title.length, isSmallContainer);
    return (_jsx(Container, { ref: containerRef, children: imageError ? (_jsx(FallbackBackground, { children: _jsxs(BottomWrap2, { backgroundColor: color, children: [_jsx(Text, { fontSize: fontSize, children: title }), _jsx(Provider, { isSmall: isSmallContainer, children: provider })] }) })) : (_jsx(ImageContainer, { imageUrl: imageUrl, children: _jsxs(BottomWrap2, { backgroundColor: color, children: [_jsx(Text, { fontSize: fontSize, children: title }), _jsx(Provider, { isSmall: isSmallContainer, children: provider })] }) })) }));
};
export default CustomThumbnail;
//# sourceMappingURL=CustomThumbnail.js.map